/**
 * 메인, 서브 페이지 공통 Layout
 */
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { shallow } from "zustand/shallow";
import TitleUpdater from "@core/components/titleUpdater/TitleUpdater";
import Header from "@core/layouts/header/Header";
import Footer from "@core/layouts/footer/Footer";
import { Toaster } from "@core/components/ui/Sonner";
import { useAuthStore } from "@core/stores/authStore";
import { useFetchLoginICafeInfo } from "@features/auth/hooks/queries/useLogin";
import { useICafeList } from "@features/account/hooks/queries/useICafeList";

export default function DefaultLayout() {
  const { pathname } = useLocation();

  /**
   * 스토어 2개
   */
  const { auth, isLogin, setPrimaryICafeId, setPlayncICafeList, setIsWithdrawn, setLoginICafeInfo } = useAuthStore(
    (state) => ({
      auth: state.auth,
      isLogin: state.isLogin,
      setPrimaryICafeId: state.setPrimaryICafeId,
      setPlayncICafeList: state.setPlayncICafeList,
      setIsWithdrawn: state.setIsWithdrawn,
      setLoginICafeInfo: state.setLoginICafeInfo,
    }),
    shallow,
  );
  /**
   * useQuery 2개
   */
  const { data: playncICafeData } = useICafeList(isLogin ?? false, auth === "PLAYNC_USER_2");
  const { data: loginICafeInfo } = useFetchLoginICafeInfo(isLogin ?? false, playncICafeData?.primaryICafeId ?? "");

  /**
   * 페이지 이동 시 스크롤 초기화
   */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  /**
   * query 결과에 따라 스토어 세팅
   */
  useEffect(() => {
    setPrimaryICafeId(playncICafeData?.primaryICafeId ?? null);
    setPlayncICafeList(playncICafeData?.iCafeList ?? null);
    setIsWithdrawn(playncICafeData?.isWithdrawn ?? false);
  }, [playncICafeData, setPrimaryICafeId, setPlayncICafeList, setIsWithdrawn]);

  useEffect(() => {
    setLoginICafeInfo(loginICafeInfo ?? null);
  }, [loginICafeInfo, setLoginICafeInfo]);

  return (
    <>
      <TitleUpdater />
      <Header />
      <Outlet />
      <Footer />
      <Toaster />
    </>
  );
}
